module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "appointment-detail-wrapper"
  }, [(_vm.dataLoaded) ? _c('div', {
    staticClass: "animated fadeIn step-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 title-section"
  }, [_c('h4', {
    staticClass: "title-text"
  }, [_vm._v(_vm._s(this.$t('message.appointment.title_edit')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('bs-dropdown', {
    staticClass: "confirm-btn-lg",
    attrs: {
      "text": _vm.appointment.status,
      "type": _vm.dropdownStatus,
      "disabled": _vm.isCancelAppointment
    }
  }, [(_vm.appointment.status !== 'checkin') ? _c('li', {
    staticClass: "status-change status-change-btn"
  }, [_c('a', {
    staticClass: "text-success",
    on: {
      "click": function($event) {
        _vm.changeStatus('scheduled')
      }
    }
  }, [_vm._v(_vm._s(this.$t('message.appointment.status_scheduled')))])]) : _vm._e(), _vm._v(" "), (_vm.appointment.status !== 'pending' && _vm.appointment.status !== 'checkin') ? _c('li', {
    staticClass: "status-change status-change-btn"
  }, [_c('a', {
    staticClass: "text-success",
    on: {
      "click": function($event) {
        _vm.changeStatus('checkin')
      }
    }
  }, [_vm._v(_vm._s(this.$t('message.appointment.status_checkin')))])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "status-change status-change-btn"
  }, [_c('a', {
    staticClass: "text-danger",
    on: {
      "click": function($event) {
        _vm.changeStatus('cancel ')
      }
    }
  }, [_vm._v(_vm._s(this.$t('message.appointment.status_cancel')))])])])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('label', {
    attrs: {
      "for": "fp"
    }
  }, [_vm._v(_vm._s(this.$t('message.appointment.label_date_time_appointment')))]), _vm._v(" "), _c('flat-pickr', {
    attrs: {
      "id": "fp",
      "config": _vm.fpConfig,
      "required": ""
    },
    model: {
      value: (_vm.appointment.appointment_time),
      callback: function($$v) {
        _vm.appointment.appointment_time = $$v
      },
      expression: "appointment.appointment_time"
    }
  }), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('label', [_vm._v(_vm._s(this.$t('message.appointment.doctor')))]), _vm._v(" "), _c('multiselect', {
    staticClass: "multi-select-form",
    attrs: {
      "id": "doctor",
      "placeholder": this.$t('message.appointment.doctor_placeholder'),
      "options": _vm.doctor_options,
      "allow-empty": true,
      "disabled": _vm.isCancelAppointment,
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.appointment.doctor),
      callback: function($$v) {
        _vm.appointment.doctor = $$v
      },
      expression: "appointment.doctor"
    }
  }), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.apmFrm.doctorIdError
    }
  }), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('div', {
    staticClass: "row col-md-12"
  }, [_c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.patient_type),
      expression: "patient_type"
    }],
    ref: "patient_type_a",
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "patient_type",
      "value": "noexists",
      "disabled": _vm.isCancelAppointment
    },
    domProps: {
      "checked": _vm._q(_vm.patient_type, "noexists")
    },
    on: {
      "__c": function($event) {
        _vm.patient_type = "noexists"
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t('message.appointment.new_patient')) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.patient_type),
      expression: "patient_type"
    }],
    ref: "patient_type_b",
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "patient_type",
      "value": "exists",
      "disabled": _vm.isCancelAppointment
    },
    domProps: {
      "checked": _vm._q(_vm.patient_type, "exists")
    },
    on: {
      "__c": function($event) {
        _vm.patient_type = "exists"
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t('message.appointment.old_patient')) + "\n            ")])])]), _vm._v(" "), (_vm.isExistingPatient) ? _c('multiselect', {
    staticClass: "multi-select-form",
    attrs: {
      "id": "patient",
      "placeholder": this.$t('message.appointment.search_patient_placeholder'),
      "options": _vm.patient_list,
      "allow-empty": true,
      "disabled": _vm.isCancelAppointment,
      "loading": _vm.patientLoading,
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    on: {
      "search-change": _vm.getPatients
    },
    model: {
      value: (_vm.selected_patient),
      callback: function($$v) {
        _vm.selected_patient = $$v
      },
      expression: "selected_patient"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('label', [_vm._v(_vm._s(this.$t('message.appointment.prefix')))]), _vm._v(" "), _c('multiselect', {
    staticClass: "multi-select-form",
    attrs: {
      "id": "prefix",
      "placeholder": this.$t('message.appointment.prefix_placeholder'),
      "options": _vm.prefix_options,
      "allow-empty": true,
      "disabled": _vm.isCancelAppointment,
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.appointment.prefix),
      callback: function($$v) {
        _vm.appointment.prefix = $$v
      },
      expression: "appointment.prefix"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('bs-input', {
    staticClass: "remove-margin-bottom",
    attrs: {
      "readonly": _vm.isExistingPatient,
      "label": this.$t('message.appointment.firstname'),
      "placeholder": this.$t('message.appointment.firstname_placeholder'),
      "required": "",
      "disabled": _vm.isCancelAppointment
    },
    model: {
      value: (_vm.appointment.firstname),
      callback: function($$v) {
        _vm.appointment.firstname = $$v
      },
      expression: "appointment.firstname"
    }
  }), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.apmFrm.firstnameError
    }
  }), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('bs-input', {
    staticClass: "remove-margin-bottom",
    attrs: {
      "readonly": _vm.isExistingPatient,
      "label": this.$t('message.appointment.lastname'),
      "placeholder": this.$t('message.appointment.lastname_placeholder'),
      "required": "",
      "disabled": _vm.isCancelAppointment
    },
    model: {
      value: (_vm.appointment.lastname),
      callback: function($$v) {
        _vm.appointment.lastname = $$v
      },
      expression: "appointment.lastname"
    }
  }), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.apmFrm.lastnameError
    }
  }), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('bs-input', {
    attrs: {
      "readonly": _vm.isExistingPatient,
      "label": this.$t('message.appointment.hn'),
      "placeholder": this.$t('message.appointment.hn'),
      "disabled": _vm.isCancelAppointment
    },
    model: {
      value: (_vm.appointment.hn),
      callback: function($$v) {
        _vm.appointment.hn = $$v
      },
      expression: "appointment.hn"
    }
  }), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body phone-section"
  }, [_c('div', [_c('label', [_vm._v(_vm._s(this.$t('message.appointment.phone')))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.appointment.phone),
      expression: "appointment.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "id": "phone",
      "readonly": _vm.isExistingPatient,
      "disabled": _vm.isCancelAppointment
    },
    domProps: {
      "value": (_vm.appointment.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.appointment.phone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.apmFrm.phoneError
    }
  }), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('bs-input', {
    staticClass: "remove-margin-bottom",
    attrs: {
      "readonly": _vm.isExistingPatient,
      "label": this.$t('message.appointment.email'),
      "type": "email",
      "placeholder": this.$t('message.appointment.email_placeholder'),
      "required": "",
      "disabled": _vm.isCancelAppointment
    },
    model: {
      value: (_vm.appointment.email),
      callback: function($$v) {
        _vm.appointment.email = $$v
      },
      expression: "appointment.email"
    }
  }), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.apmFrm.emailError
    }
  }), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('label', [_vm._v(_vm._s(this.$t('message.appointment.seen_doctor')))]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.appointment.seen_doctor),
      expression: "appointment.seen_doctor"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "seen_doctor",
      "value": "1",
      "disabled": _vm.isCancelAppointment
    },
    domProps: {
      "checked": _vm._q(_vm.appointment.seen_doctor, "1")
    },
    on: {
      "__c": function($event) {
        _vm.appointment.seen_doctor = "1"
      }
    }
  }), _vm._v(" " + _vm._s(this.$t('message.appointment.have')) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.appointment.seen_doctor),
      expression: "appointment.seen_doctor"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "seen_doctor",
      "value": "0",
      "disabled": _vm.isCancelAppointment
    },
    domProps: {
      "checked": _vm._q(_vm.appointment.seen_doctor, "0")
    },
    on: {
      "__c": function($event) {
        _vm.appointment.seen_doctor = "0"
      }
    }
  }), _vm._v(" " + _vm._s(this.$t('message.appointment.have_not')) + "\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('label', [_vm._v(_vm._s(this.$t('message.appointment.medical_record')))]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.appointment.has_medical_record),
      expression: "appointment.has_medical_record"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "has_medical_record",
      "value": "1",
      "disabled": _vm.isCancelAppointment
    },
    domProps: {
      "checked": _vm._q(_vm.appointment.has_medical_record, "1")
    },
    on: {
      "__c": function($event) {
        _vm.appointment.has_medical_record = "1"
      }
    }
  }), _vm._v(" " + _vm._s(this.$t('message.appointment.have_yes')) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.appointment.has_medical_record),
      expression: "appointment.has_medical_record"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "has_medical_record",
      "value": "0",
      "disabled": _vm.isCancelAppointment
    },
    domProps: {
      "checked": _vm._q(_vm.appointment.has_medical_record, "0")
    },
    on: {
      "__c": function($event) {
        _vm.appointment.has_medical_record = "0"
      }
    }
  }), _vm._v(" " + _vm._s(this.$t('message.appointment.have_no')) + "\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('label', [_vm._v(_vm._s(this.$t('message.appointment.booking_for')))]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.appointment.for),
      expression: "appointment.for"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "for",
      "value": "myself",
      "disabled": _vm.isCancelAppointment
    },
    domProps: {
      "checked": _vm._q(_vm.appointment.for, "myself")
    },
    on: {
      "__c": function($event) {
        _vm.appointment.for = "myself"
      }
    }
  }), _vm._v(" " + _vm._s(this.$t('message.appointment.myself')) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.appointment.for),
      expression: "appointment.for"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "for",
      "value": "other",
      "disabled": _vm.isCancelAppointment
    },
    domProps: {
      "checked": _vm._q(_vm.appointment.for, "other")
    },
    on: {
      "__c": function($event) {
        _vm.appointment.for = "other"
      }
    }
  }), _vm._v(" " + _vm._s(this.$t('message.appointment.another')) + "\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('bs-input', {
    attrs: {
      "label": this.$t('message.appointment.id_card'),
      "readonly": _vm.isExistingPatient,
      "placeholder": this.$t('message.appointment.id_card'),
      "required": "",
      "disabled": _vm.isCancelAppointment
    },
    model: {
      value: (_vm.appointment.id_card),
      callback: function($$v) {
        _vm.appointment.id_card = $$v
      },
      expression: "appointment.id_card"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('label', {
    attrs: {
      "for": "fp"
    }
  }, [_vm._v(_vm._s(this.$t('message.appointment.birthdate')))]), _vm._v(" "), _c('flat-pickr', {
    attrs: {
      "id": "fp",
      "config": _vm.fpConfigBirthday,
      "required": ""
    },
    model: {
      value: (_vm.appointment.birthday),
      callback: function($$v) {
        _vm.appointment.birthday = $$v
      },
      expression: "appointment.birthday"
    }
  }), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(_vm._s(this.$t('message.appointment.service')))]), _vm._v(" "), _c('multiselect', {
    staticClass: "multi-select-form",
    attrs: {
      "id": "service",
      "placeholder": this.$t('message.appointment.service_placeholder'),
      "options": _vm.service_options,
      "allow-empty": true,
      "disabled": _vm.isCancelAppointment,
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.appointment.service),
      callback: function($$v) {
        _vm.appointment.service = $$v
      },
      expression: "appointment.service"
    }
  }), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(_vm._s(this.$t('message.appointment.duration')))]), _vm._v(" "), _c('bs-input', {
    staticClass: "input-min",
    attrs: {
      "type": "Number",
      "min": "15",
      "max": "1440",
      "step": 15,
      "placeholder": this.$t('message.appointment.duration_placeholder'),
      "disabled": _vm.isCancelAppointment
    },
    model: {
      value: (_vm.appointment.duration),
      callback: function($$v) {
        _vm.appointment.duration = _vm._n($$v)
      },
      expression: "appointment.duration"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    slot: "after"
  }, [_c('strong', [_vm._v(_vm._s(this.$t('message.appointment.duration_unit')))])])])], 1)])]), _vm._v(" "), (_vm.appointment.comment) ? _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('message.appointment.addition')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.appointment.comment))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('message.appointment.locale')))]), _vm._v(" "), _c('multiselect', {
    staticClass: "multi-select-form",
    attrs: {
      "id": "locale",
      "placeholder": _vm.$t('message.appointment.locale_placeholder'),
      "options": _vm.locale_options,
      "allow-empty": false,
      "disabled": _vm.isCancelAppointment,
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.appointment.locale),
      callback: function($$v) {
        _vm.appointment.locale = $$v
      },
      expression: "appointment.locale"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('div', [_vm._l((_vm.templates.remark_templates), function(rt) {
    return _c('button', {
      key: rt.name,
      staticClass: "btn btn-secondary btn-sm btn-remark-template",
      attrs: {
        "type": "button",
        "disabled": _vm.isCancelAppointment
      },
      on: {
        "click": function($event) {
          _vm.appendRemark(rt.text)
        }
      }
    }, [_vm._v(_vm._s(rt.name))])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary btn-sm btn-success",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openRemarkEditor($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  })])], 2), _vm._v(" "), _c('bs-input', {
    ref: "remark",
    attrs: {
      "type": "textarea",
      "label": this.$t('message.appointment.remark'),
      "placeholder": this.$t('message.appointment.remark_placeholder'),
      "disabled": _vm.isCancelAppointment
    },
    model: {
      value: (_vm.appointment.remark),
      callback: function($$v) {
        _vm.appointment.remark = $$v
      },
      expression: "appointment.remark"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('bs-input', {
    attrs: {
      "type": "textarea",
      "label": this.$t('message.appointment.admin_remark'),
      "placeholder": this.$t('message.appointment.admin_remark_placeholder'),
      "disabled": _vm.isCancelAppointment
    },
    model: {
      value: (_vm.appointment.admin_note),
      callback: function($$v) {
        _vm.appointment.admin_note = $$v
      },
      expression: "appointment.admin_note"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body form-group action-group"
  }, [_c('button', {
    staticClass: "btn btn-cancel btn-lg",
    on: {
      "click": _vm.back
    }
  }, [_vm._v(_vm._s(this.$t('action_message.back')))]), _vm._v(" "), (!_vm.isCancelAppointment) ? _c('button', {
    staticClass: "btn btn-store btn-lg",
    on: {
      "click": _vm.saveAppointment
    }
  }, [_vm._v(_vm._s(this.$t('action_message.save')))]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "btn btn-sm"
  }, [_c('sync-loader', {
    attrs: {
      "size": "10px"
    }
  })], 1)])])]) : _c('div', {
    staticClass: "animated fadeIn step-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2 offset-md-5"
  }, [_c('dot-loader', {
    attrs: {
      "loading": true,
      "size": "60px"
    }
  })], 1)])])])]), _vm._v(" "), _c('sweet-modal', {
    ref: "remarkModal",
    attrs: {
      "overlay-theme": "dark"
    }
  }, [_c('remark-editor', {
    attrs: {
      "remarks": _vm.templates.remark_templates
    },
    on: {
      "update:remarks": function($event) {
        _vm.templates.remark_templates = $event
      },
      "closeEditor": _vm.closeRemarkModal,
      "submitRemark": _vm.updateRemarks
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-976f0648"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/appointment/AppointmentDetail.vue
// module id = 1044
// module chunks = 1